var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopSearchCardStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF8297"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51054 6.95001C7.82966 6.95001 7.23419 7.4086 7.06029 8.0669L6.02887 11.9712C5.91158 12.4152 6.24641 12.85 6.70566 12.85H7.18564V13V15.9C7.18564 16.4523 7.63335 16.9 8.18564 16.9H10.4047H12.8428H15.0618C15.6141 16.9 16.0618 16.4523 16.0618 15.9V13C16.0618 12.949 16.058 12.8989 16.0507 12.85H16.5418C17.0011 12.85 17.3359 12.4152 17.2186 11.9712L16.1872 8.0669C16.0133 7.4086 15.4178 6.95001 14.7369 6.95001H8.51054ZM12.8428 15.9L10.4047 15.9V15.1L12.8428 15.1V15.9ZM15.0618 15.9L13.8428 15.9V15.1C13.8428 14.5477 13.3951 14.1 12.8428 14.1H10.4047C9.8524 14.1 9.40469 14.5477 9.40469 15.1V15.9H8.18564V13H15.0618V15.9ZM8.02712 8.32231C8.08509 8.10288 8.28358 7.95001 8.51054 7.95001H14.7369C14.9639 7.95001 15.1624 8.10288 15.2204 8.32231L16.1523 11.85H14.4307C14.4894 11.7513 14.5138 11.6314 14.4909 11.5085L14.1603 9.73409C14.1097 9.46262 13.8479 9.2794 13.5755 9.32485C13.3031 9.3703 13.1233 9.62721 13.1739 9.89868L13.5045 11.6731C13.5166 11.7377 13.5406 11.7973 13.5738 11.85H11.8506C11.9391 11.7598 11.9936 11.6363 11.9936 11.5V9.70001C11.9936 9.42387 11.7697 9.20001 11.4936 9.20001C11.2174 9.20001 10.9936 9.42387 10.9936 9.70001V11.5C10.9936 11.6363 11.0481 11.7598 11.1365 11.85H9.2594C9.37918 11.7771 9.46882 11.6558 9.49627 11.5085L9.82688 9.73409C9.87746 9.46262 9.69766 9.20571 9.42528 9.16026C9.15291 9.1148 8.8911 9.29803 8.84052 9.5695L8.50991 11.3439C8.47161 11.5494 8.56539 11.7466 8.73142 11.85H7.0952L8.02712 8.32231Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopSearchCardStop);
export default __webpack_public_path__ + "static/media/stop-search-card-stop.4aef816367c49023e855db8642f74e97.svg";
export { ForwardRef as ReactComponent };